/** Client-side date range filter (inclusive, local calendar days). */
export const isDateInRange = (dateValue, fromDate, toDate) => {
  if (!dateValue || !fromDate || !toDate) return false;
  const date = new Date(dateValue);
  const from = new Date(`${fromDate}T00:00:00`);
  const to = new Date(`${toDate}T23:59:59.999`);
  return date >= from && date <= to;
};

export const filterByDateRange = (items, getDate, fromDate, toDate) =>
  items.filter((item) => isDateInRange(getDate(item), fromDate, toDate));
